import { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { useSearchParams } from 'next/navigation';

import { firebaseAuthClient } from '@/src/modules/auth/auth.config';

export const useHeader = () => {
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState<User | null>(null);

  const search = useSearchParams();

  onAuthStateChanged(firebaseAuthClient, async firebaseUser => {
    setUser(firebaseUser);
  });

  useEffect(() => {
    // retrieves promocode for 'deeplinks'
    search.forEach((value, index) => {
      if (index === 'promocode') {
        localStorage.setItem(index, value);
      }
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100 && !open) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  useEffect(() => {
    if (open) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }

    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [open]);

  return { showHeader, open, setOpen, user };
};
